// https://css-tricks.com/snippets/javascript/javascript-keycodes/
export const KEYCODE_MAP = {
  BACKSPACE: 8,
  UP_ARROW: 38,
  DOWN_ARROW: 40,
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32
};
